import React, { FC } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { ArticlePreviewCard } from "@app/components/article-preview-card/ArticlePreviewCard";
import { PostSummary } from "@app/models";

type Props = {
  publications: PostSummary[];
};

export const RelatedPublications: FC<Props> = ({ publications }) => {
  const { t } = useTranslation("t_blog");

  return (
    <div className={classNames("mt-15", "xxl:mt-40")}>
      <h3
        className={classNames(
          "mb-6 text-medium text-primary-content",
          "lg:mb-7.5 lg:text-large",
        )}
      >
        {t("related_publications")}
      </h3>
      <div
        className={classNames(
          "grid grid-cols-1 gap-y-15",
          "md:grid-cols-2 md:gap-x-10",
          "xxl:grid-cols-3 xxl:gap-x-12",
        )}
      >
        {publications.map((publication) => (
          <ArticlePreviewCard key={publication.title} {...publication} />
        ))}
      </div>
    </div>
  );
};
